import { render, staticRenderFns } from "./groupSkuBox.vue?vue&type=template&id=148e0884&scoped=true"
import script from "./groupSkuBox.vue?vue&type=script&lang=js"
export * from "./groupSkuBox.vue?vue&type=script&lang=js"
import style0 from "./groupSkuBox.vue?vue&type=style&index=0&id=148e0884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e0884",
  null
  
)

export default component.exports